import React, { Component } from 'react';

export class CreateBox extends Component {

  render() {

    return (
      <div className="CardBox">
        <div className="CreateBox">
          <p className="CreateText">
            Create Deck!
          </p>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/CreateBox.js